export { useCloseOnResize } from './useCloseOnResize';
